import { Orientation as T } from "./Orientation.js";
import { Rect as h } from "./Rect.js";
class e {
  static values = {};
  static TOP = new e("top", T.VERT, 0);
  static BOTTOM = new e("bottom", T.VERT, 1);
  static LEFT = new e("left", T.HORZ, 0);
  static RIGHT = new e("right", T.HORZ, 1);
  static CENTER = new e("center", T.VERT, 0);
  /** @internal */
  static getByName(t) {
    return e.values[t];
  }
  /** @internal */
  static getLocation(t, n, i) {
    if (n = (n - t.x) / t.width, i = (i - t.y) / t.height, n >= 0.25 && n < 0.75 && i >= 0.25 && i < 0.75)
      return e.CENTER;
    const s = i >= n, u = i >= 1 - n;
    return s ? u ? e.BOTTOM : e.LEFT : u ? e.RIGHT : e.TOP;
  }
  /** @internal */
  _name;
  /** @internal */
  _orientation;
  /** @internal */
  _indexPlus;
  /** @internal */
  constructor(t, n, i) {
    this._name = t, this._orientation = n, this._indexPlus = i, e.values[this._name] = this;
  }
  equals(t) {
    return this._name === t._name && this._orientation.getName() === t._orientation.getName() && this._indexPlus === t._indexPlus;
  }
  getName() {
    return this._name;
  }
  getOrientation() {
    return this._orientation;
  }
  /** @internal */
  getDockRect(t) {
    return this === e.TOP ? new h(t.x, t.y, t.width, t.height / 2) : this === e.BOTTOM ? new h(t.x, t.getBottom() - t.height / 2, t.width, t.height / 2) : this === e.LEFT ? new h(t.x, t.y, t.width / 2, t.height) : this === e.RIGHT ? new h(t.getRight() - t.width / 2, t.y, t.width / 2, t.height) : t.clone();
  }
  /** @internal */
  split(t, n) {
    if (this === e.TOP) {
      const i = new h(t.x, t.y, t.width, n), s = new h(t.x, t.y + n, t.width, t.height - n);
      return { start: i, end: s };
    } else if (this === e.LEFT) {
      const i = new h(t.x, t.y, n, t.height), s = new h(t.x + n, t.y, t.width - n, t.height);
      return { start: i, end: s };
    }
    if (this === e.RIGHT) {
      const i = new h(t.getRight() - n, t.y, n, t.height), s = new h(t.x, t.y, t.width - n, t.height);
      return { start: i, end: s };
    } else {
      const i = new h(t.x, t.getBottom() - n, t.width, n), s = new h(t.x, t.y, t.width, t.height - n);
      return { start: i, end: s };
    }
  }
  /** @internal */
  reflect() {
    return this === e.TOP ? e.BOTTOM : this === e.LEFT ? e.RIGHT : this === e.RIGHT ? e.LEFT : e.TOP;
  }
  toString() {
    return "(DockLocation: name=" + this._name + ", orientation=" + this._orientation + ")";
  }
}
export {
  e as DockLocation
};
//# sourceMappingURL=DockLocation.js.map
